exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stripo {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 999;\n  background: #f00;\n}\n.stripo .nav {\n  display: block;\n}\n.stripo .full-height {\n  height: 100%;\n}\n.stripo #stripoSettingsContainer {\n  width: 350px;\n  height: 100%;\n  float: left;\n  background: #0ee;\n}\n.stripo #stripoPreviewContainer {\n  height: 100%;\n  width: calc(100% - 350px);\n  float: left;\n}", ""]);

// exports
